/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { PrimengMenuItem } from './helpers/menu-item.interface';
import { MenuProviderHandler } from './helpers/menu-provider-handler';
import { PrimengMenuHandler } from './helpers/primeng-menu-handler';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class MenuService {
  constructor(private readonly menuProvider: MenuProviderHandler) {}

  getPrimengMenu(): Observable<PrimengMenuItem[]> {
    return this.menuProvider.getProviderMenuItem().pipe(
      map((data) => {
        const menuItems: any = [];

        data.map((item) => {
          menuItems.push(...item);
        });

        const primengHandler = new PrimengMenuHandler(menuItems);

        return primengHandler.getMenu();
      })
    );
  }
}
